export default [
  {
    path: "/usuarios",
    component: () => import("@/views/usuarios/Listar.vue"),
  },
  {
    path: "/usuarios/crear",
    component: () => import("@/views/usuarios/Crear.vue"),
  },
  {
    path: "/usuarios/editar/:id",
    component: () => import("@/views/usuarios/Editar.vue"),
  },
];
